import { useTransl } from 'shared/lib/i18n';

import {
  StyledDivider,
  StyledDividerLine,
  StyledDividerText,
} from './styledComponents';

const AuthDivider = () => {
  const { t } = useTransl();
  return (
    <StyledDivider>
      <StyledDividerLine />
      <StyledDividerText>{t('auth.or')}</StyledDividerText>
      <StyledDividerLine />
    </StyledDivider>
  );
};

export default AuthDivider;
